import { createApp, markRaw } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import * as fr from '@/localization/fr.json';
import * as en from '@/localization/en.json';
import * as es from '@/localization/es.json'

import { createPinia } from 'pinia';

import KeycloakService from './services/keycloakService';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'srh-ui/dist/srh-ui-styles.js';
import 'srh-ui/dist/srh-ui-styles.css';
import '@/assets/style.css';

// @ts-ignore
import SrhUiI18nService from 'srh-ui/dist/services/i18n';
// @ts-ignore
import SrhUiPlugin from 'srh-ui';

let srhUiI18nService = new SrhUiI18nService();
const messages = Object.assign({}, fr, en, es);
srhUiI18nService.setLocale(window.navigator.language);
srhUiI18nService.addMessages(messages);
srhUiI18nService.setLegacy(false);

const app = createApp(App);

const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});

app.use(pinia);

app.use(router);

app.use(ElementPlus);

app.use(SrhUiPlugin, { i18nService: srhUiI18nService });

const renderApp = () => {
  app.mount('#app');
};

KeycloakService.CallLogin(renderApp);
